enum UIKeys {
  transitionPriorities = "transition_priorities",
  snaplines = "snaplines",
  gridEnabled = "grid",
  gridShow = "grid_display",
  gridSize = "grid_size",
  darkTheme = "dark_theme",
}

export default UIKeys;
